import React, {useContext} from "react";
import { Link } from "react-router-dom";

import { ThemeContext } from "src/helpers/themeContext";
//import components
import SidebarContent from "./SidebarContent";
import SimpleBar from "simplebar-react";

//import images
import logoSm from "../../assets/images/logo-sm.png";
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";

const Sidebar = (props: any) => {
  const Theme = useContext(ThemeContext)
  function tToggle() {
    document.body.setAttribute("data-sidebar-size", "sm");
  }

  return (
    <React.Fragment>
      <div className="vertical-menu">

        <div className="navbar-brand-box">
          <Link to="/sales" className="logo logo-dark">
            <span className="logo-sm">
              <img src={Theme.images.icon} alt="logosm dark" height="35" />
            </span>
            <span className="logo-lg">
              <img src={Theme.images.icon} alt="logolg dark" width="80%" />
            </span>
          </Link>

          <Link to="/sales" className="logo logo-light">
            <span className="logo-sm">
              <img src={Theme.images.icon} alt="logosm light" height="35" />
            </span>
            <span className="logo-lg">
              <img src={Theme.images.logo} alt="logolg light" width="80%" />
            </span>
          </Link>
        </div>

        <button
          onClick={() => {
            tToggle();
          }}
          type="button" className="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn" id="vertical-menu-btn">
          <i className="fa fa-fw fa-bars" />
        </button>

        <div className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;